import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export const useFormationPageVM = () => {
    const [isDisabled] = useState<boolean>(false);
    const navigate = useNavigate();
    const steps = ['Découvrez les instructions', 'Répondez aux questions', "Signez l'émargement", 'La formation est validée'];

    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsDisabled(false);
    //     }, 3800);
    // }, []);

    return { isDisabled, navigate, steps };
};
